/* globals localStorage */

export default {
  
  firstName: null,
  lastName: null,
  profilePhoto: null,

  profile (httpInstance, cb) {
      cb = arguments[arguments.length - 1]
      if (this.firstName && this.lastName) {
        if (cb) cb(true)
        this.onChange(true)
        return
      }

      getProfile(httpInstance, (res) => {
        if(res.firstName) {
          this.firstName = res.firstName
          this.lastName = res.lastName
          this.profilePhoto = res.photo
          if (cb) cb(true)
          this.onChange(true)

        }else{
          if (cb) cb(false)
          this.onChange(false)
        }
      })
  },

 
  onChange () {}
  }
  
  function getProfile (httpInstance, cb) {
    httpInstance.get('/profiles')
    .then(response =>{
      cb({
        firstName: response.data[0].firstName,
        lastName: response.data[0].lastName,
        photo: response.data[0].photo
      }) 
    })
    .catch((error) => {
      console.log(error);
    });
    
  }
  